// MOBIL-NAV-02, Betreiberfreigabe 29.10.2026 — Menü-Knopf der Handy-Kopfleiste (unter 768 px) mit Liste aller übergebenen Bereiche
import { useState } from "react";
import { NavLink } from "react-router-dom";
import * as SheetPrimitive from "@radix-ui/react-dialog";
import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { Sheet, SheetTrigger, SheetPortal, SheetOverlay, SheetClose, SheetTitle } from "@/components/ui/sheet";

// MOBIL-NAV-02, Betreiberfreigabe 29.10.2026 — Klassen wie ui/sheet.jsx (Seite "right"), eigener Schließen-Knopf „Menü schließen“
const INHALT_KLASSEN =
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm overflow-y-auto";

export default function UnternehmerHandyNav({ items }) {
  const [offen, setOffen] = useState(false);
  return (
    <Sheet open={offen} onOpenChange={setOffen}>
      <SheetTrigger asChild>
        <button
          type="button"
          aria-label="Menü"
          className="md:hidden inline-flex items-center justify-center w-11 h-11 rounded-md text-slate-700 hover:bg-slate-100"
          data-testid="mobile-nav-menu-button"
        >
          <Menu className="w-6 h-6" />
        </button>
      </SheetTrigger>
      <SheetPortal>
        <SheetOverlay />
        <SheetPrimitive.Content className={INHALT_KLASSEN} aria-describedby={undefined} data-testid="mobile-nav-sheet">
          <SheetTitle className="sr-only">Menü</SheetTitle>
          <SheetClose
            aria-label="Menü schließen"
            className="absolute right-3 top-3 inline-flex items-center justify-center w-11 h-11 rounded-md text-slate-700 hover:bg-slate-100"
            data-testid="mobile-nav-close-button"
          >
            <X className="w-5 h-5" />
          </SheetClose>
          <nav aria-label="Bereiche" className="mt-12 flex flex-col gap-1">
            {items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setOffen(false)}
                data-testid={`mobile-nav-item-${item.testId.replace(/^nav-/, "")}`}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium",
                    isActive ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-100"
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={cn(
                        "w-8 h-8 rounded-md text-white flex items-center justify-center shrink-0",
                        isActive ? "bg-white/10" : "bg-slate-900"
                      )}
                    >
                      <item.icon className="w-4 h-4" />
                    </span>
                    {item.label}
                  </>
                )}
              </NavLink>
            ))}
          </nav>
        </SheetPrimitive.Content>
      </SheetPortal>
    </Sheet>
  );
}
